import Vue from "vue";
import Vuex from "vuex";
import * as FamilyStore from "@/store/modules/FamilyStore.js";
import * as UserStore from "@/store/modules/UserStore.js";
import * as AlbumStore from "@/store/modules/AlbumStore.js";
import * as AdventureStore from "@/store/modules/AdventureStore.js";
import * as NotificationStore from "@/store/modules/NotificationStore.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    FamilyStore,
    UserStore,
    AlbumStore,
    AdventureStore,
    NotificationStore
  }
});
